/**
 * Class description
 *
 * Created: 2017-10-09
 * @author jonas
 */
import {ILayerConfig, ILayersConfig} from "@nolimitcity/slot-game/bin/core/stage/ILayersConfig";
import {CustomLayerScaleOptions, LayerScaleOption} from "@nolimitcity/slot-game/bin/core/stage/LayerScaleOption";
import {IDeviceDependentConfig} from "@nolimitcity/slot-game/bin/core/useragent/UserAgent";


export class DirtyWildsLayerConfig {

    public static defaultLayerScaleOptions:IDeviceDependentConfig<LayerScaleOption> = {
        desktop : {
            landscape : LayerScaleOption.REELS_FIT_STAGE,
            portrait : LayerScaleOption.REELS_FIT_STAGE
        },
        mobile : {
            landscape : LayerScaleOption.REELS_FIT_STAGE,
            portrait : LayerScaleOption.REELS_FIT_STAGE
        }
    };

    public static defaultPlacement:CustomLayerScaleOptions = {
        placement : {x : 0.5, y : 0.75},
        frame : {x : 0, y : 0, width : 720, height : 620},
    };


    public static ENV_BACK:ILayerConfig = {
        name : "env_back",
        customOptions : DirtyWildsLayerConfig.defaultPlacement
    };

    public static ENV_MID:ILayerConfig = {
        name : "env_mid",
        customOptions : DirtyWildsLayerConfig.defaultPlacement
    };

    public static ENV_FRONT:ILayerConfig = {
        name : "env_front",
        customOptions : DirtyWildsLayerConfig.defaultPlacement
    };


    public static BET_LINES:ILayerConfig = {
        name : "bet_lines",
        customOptions : DirtyWildsLayerConfig.defaultPlacement
    };

    public static SYMBOLS_NO_WIN:ILayerConfig = {
        name : "symbols_no_win",
        customOptions : DirtyWildsLayerConfig.defaultPlacement
    };

    //Is used by framework
    public static SYMBOLS:ILayerConfig = {
        name : "symbols",
        customOptions : DirtyWildsLayerConfig.defaultPlacement
    };

    public static SYMBOLS_MIDDLE:ILayerConfig = {
        name : "symbols_middle",
        customOptions : DirtyWildsLayerConfig.defaultPlacement
    };

    public static SYMBOLS_TOP:ILayerConfig = {
        name : "symbols_top",
        customOptions : DirtyWildsLayerConfig.defaultPlacement
    };

    public static INDIVIDUAL_SYM_WIN_AMOUNT:ILayerConfig = {
        name : "INDIVIDUAL_SYM_WIN_AMOUNT",
        customOptions : DirtyWildsLayerConfig.defaultPlacement
    };

    public static SYMBOLS_ATTENTION:ILayerConfig = {
        name : "symbols_attention",
        customOptions : DirtyWildsLayerConfig.defaultPlacement
    };

    public static TOP_BAR_LAYER:ILayerConfig = {
        name : "top_bar_layer",
        customOptions : DirtyWildsLayerConfig.defaultPlacement
    };

    public static FIRE_TRAIL_LAYER:ILayerConfig = {
        name : "fire_trail_layer",
        customOptions : DirtyWildsLayerConfig.defaultPlacement
    };

    public static NEAR_WIN_DIV_ATTENTIONS:ILayerConfig = {
        name : "near_win_div_attentions",
        customOptions : DirtyWildsLayerConfig.defaultPlacement
    };

    public static WIN_DISPLAY:ILayerConfig = {
        name : "win_display",
        customOptions : DirtyWildsLayerConfig.defaultPlacement
    };

    public static DEBUG_OVERLAY:ILayerConfig = {name : "debug_overlay", scaleOption : LayerScaleOption.NONE};

    public static INTRO:ILayerConfig = {name : "intro", scaleOption : LayerScaleOption.FIT_WINDOW};

    public static MAIN_FEATURE_OUTRO:ILayerConfig = {
        name : "main_feature_outro",
        scaleOption : LayerScaleOption.FIT_WINDOW
    };


    //This determines the layer order.
    public static getConfig():ILayersConfig {
        return {
            ENV_BACK : DirtyWildsLayerConfig.ENV_BACK,
            ENV_MID : DirtyWildsLayerConfig.ENV_MID,
            ENV_FRONT : DirtyWildsLayerConfig.ENV_FRONT,
            SYMBOLS_NO_WIN : DirtyWildsLayerConfig.SYMBOLS_NO_WIN,
            SYMBOLS : DirtyWildsLayerConfig.SYMBOLS,
            SYMBOLS_MIDDLE : DirtyWildsLayerConfig.SYMBOLS_MIDDLE,
            TOP_BAR_LAYER : DirtyWildsLayerConfig.TOP_BAR_LAYER,
            SYMBOLS_TOP : DirtyWildsLayerConfig.SYMBOLS_TOP,
            INDIVIDUAL_SYM_WIN_AMOUNT:DirtyWildsLayerConfig.INDIVIDUAL_SYM_WIN_AMOUNT,
            SYMBOLS_ATTENTION : DirtyWildsLayerConfig.SYMBOLS_ATTENTION,
            // NEAR_WIN_DIV_ATTENTIONS : DirtyWildsLayerConfig.NEAR_WIN_DIV_ATTENTIONS,
            FIRE_TRAIL_LAYER : DirtyWildsLayerConfig.FIRE_TRAIL_LAYER,

            BET_LINES : DirtyWildsLayerConfig.BET_LINES,
            MAIN_FEATURE_OUTRO : DirtyWildsLayerConfig.MAIN_FEATURE_OUTRO,
            WIN_DISPLAY : DirtyWildsLayerConfig.WIN_DISPLAY,
            DEBUG_OVERLAY : DirtyWildsLayerConfig.DEBUG_OVERLAY,
            INTRO : DirtyWildsLayerConfig.INTRO,
            NEAR_WIN_DIV_ATTENTIONS : DirtyWildsLayerConfig.NEAR_WIN_DIV_ATTENTIONS
        };
    }

}